const alertsReducer = (state, action) => {
	let newState = { ...state };
	try {
		switch (action.type) {
			case 'discard':
				//find id in items then remove
				newState.items.splice(newState.items.indexOf(action.payload), 1);
				break;
			case 'add':
				//find id in items then remove
                newState.items.push(action.payload)            
				newState.count = newState.items.length
				break;
			case 'reset':
                newState = alertsInit([]);
                break;
			default:
				throw new Error();
		}
	} catch (e) {
		console.info('ERROR alertsReducer', e);
	}
	return newState;
};
const alertsInit = (mylist) => {
	return { items: mylist, count: mylist.length };
};

export { alertsInit, alertsReducer };
